var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 21V16C8 15.0572 8 14.5858 7.70711 14.2929C7.41421 14 6.94281 14 6 14H5.5C4.08579 14 3.37868 14 2.93934 14.4393C2.5 14.8787 2.5 15.5858 2.5 17V21H8ZM8 21H14M8 21V15C8 13.5858 8 12.8787 8.43934 12.4393C8.87868 12 9.58579 12 11 12C12.4142 12 13.1213 12 13.5607 12.4393C14 12.8787 14 13.5858 14 15V21M14 21H19.5V19C19.5 17.5858 19.5 16.8787 19.0607 16.4393C18.6213 16 17.9142 16 16.5 16H16C15.0572 16 14.5858 16 14.2929 16.2929C14 16.5858 14 17.0572 14 18V21ZM1 21H21M11.6911 1.57767L12.395 2.99715C12.491 3.19475 12.7469 3.38428 12.9629 3.42057L14.2388 3.6343C15.0547 3.77141 15.2467 4.36824 14.6587 4.957L13.6668 5.95709C13.4989 6.12646 13.4069 6.4531 13.4589 6.68699L13.7428 7.925C13.9668 8.90492 13.4509 9.28399 12.591 8.77185L11.3951 8.05808C11.1791 7.92903 10.8232 7.92903 10.6032 8.05808L9.40731 8.77185C8.5514 9.28399 8.03146 8.90089 8.25543 7.925L8.5394 6.68699C8.5914 6.4531 8.49941 6.12646 8.33143 5.95709L7.33954 4.957C6.7556 4.36824 6.94358 3.77141 7.75949 3.6343L9.03535 3.42057C9.24732 3.38428 9.5033 3.19475 9.59929 2.99715L10.3032 1.57767C10.6872 0.807443 11.3111 0.807443 11.6911 1.57767Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRated);
export default __webpack_public_path__ + "static/media/Rated.3338c41c02ff139abf85e178702778bc.svg";
export { ForwardRef as ReactComponent };